module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app",
    attrs: {
      "id": "app",
      "data-route": _vm.$route.name,
      "data-theme": _vm.theme
    },
    on: {
      "mousemove": _vm.resetSleepTimer
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.navTransition
    }
  }, [_c('app-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteIntro && _vm.navVisible),
      expression: "!siteIntro && navVisible"
    }],
    attrs: {
      "window": _vm.window,
      "siteIntro": _vm.siteIntro,
      "site": _vm.site,
      "collections": _vm.collections
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app__body"
  }, [_c('transition', {
    attrs: {
      "name": _vm.pageTransition
    }
  }, [_c('router-view', {
    attrs: {
      "window": _vm.window,
      "mobile": _vm.isMobile,
      "siteIntro": _vm.siteIntro,
      "site": _vm.site,
      "collections": _vm.collections
    },
    on: {
      "toggleNav": function($event) {
        _vm.navVisible = !_vm.navVisible
      },
      "cinemagraph-playing": _vm.endIntro,
      "changeTheme": _vm.changeTheme
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "longfade"
    }
  }, [(_vm.siteIntro || _vm.sleepMode.active) ? _c('screensaver', {
    attrs: {
      "sleepMode": _vm.sleepMode.active,
      "siteIntro": _vm.siteIntro,
      "site": _vm.site
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('subscribe-pop-up', {
    attrs: {
      "ready": _vm.siteReady
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-056e9654"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 371
// module chunks = 1